export default function () {
  var pathParts = window.location.pathname.split("/");
  return pathParts[pathParts.length - 1];
}
